<template>
  <div class="my-5 w-full lg:p-4">
    <TempRelatedProducts />
    <div id="relatedProducts" class="hidden"></div>
  </div>
</template>

<script setup lang="ts">
import TempRelatedProducts from '@/pages/ProductPage/partials/TempRelatedProducts.vue';
import { useAlgoliaProductStore } from '@/stores/Category/AlgoliaProductStore';
import { useAlgoliaSearchStore } from '@/stores/Category/AlgoliaSearchStore';
import instantsearch from 'instantsearch.js';
import { carousel } from 'instantsearch.js/es/templates';
import { relatedProducts } from 'instantsearch.js/es/widgets';
import { onMounted } from 'vue';

const productStore = useAlgoliaProductStore();
const searchStore = useAlgoliaSearchStore();
const enableRealRelatedProducts = false;

onMounted(() => {
  if (enableRealRelatedProducts) {
    return;
  }

  // TODO right now, this does not work because we do not have enough trained data.
  const search = instantsearch({
    searchClient: searchStore.getLiteClient(),
    indexName: productStore.productIndex,
  }).addWidgets([
    relatedProducts({
      container: '#relatedProducts',
      objectIDs: [window.product.sku],
      templates: {
        item(recommendation, { html }) {
          return html`
            <h2>${recommendation.name}</h2>
            <p>${recommendation.description}</p>
          `;
        },
        layout: carousel(),
      },
    }),
  ]);
  search.start();
});
</script>
